/* eslint-disable import/prefer-default-export */
import { call, put } from 'redux-saga/effects';

import request from './request';
import { rebootSystemFailed, rebootSystemRequested, rebootSystemSucceeded } from '../../../actions';
import api from '../../../api';

export function* rebootSystemRequest() {
  yield put(rebootSystemRequested());

  try {
    const { success } = yield call(request, api.rebootSystem);

    const action = rebootSystemSucceeded(success);
    yield put(action);

    return {
      success,
    };
  } catch (error) {
    const action = rebootSystemFailed(error);
    yield put(action);

    return {
      success: false,
    };
  }
}
